/**
 * ワースケ（日別シフト）表示設定の型定義
 */

/**
 * エリア1（従業員名表示）の選択肢
 */
export type DailyArea1Option = "employeeName";

/**
 * エリア2, 3（詳細情報表示）の選択肢
 */
export type DailyArea2And3Option =
    | "none"
    | "employmentType"
    | "employeeCode"
    | "dailyWorkHours";

/**
 * ワースケ従業員セル表示設定
 */
export interface DailyShiftCellDisplaySettings {
    area1: DailyArea1Option;
    area2: DailyArea2And3Option;
    area3: DailyArea2And3Option;
}

/**
 * エリア1の選択肢ラベル定義
 */
export const DAILY_AREA1_OPTIONS: { value: DailyArea1Option; label: string }[] = [
    { value: "employeeName", label: "従業員名" },
];

/**
 * エリア2, 3の選択肢ラベル定義
 */
export const DAILY_AREA2_AND_3_OPTIONS: { value: DailyArea2And3Option; label: string }[] = [
    { value: "none", label: "表示しない" },
    { value: "employmentType", label: "雇用形態名" },
    { value: "employeeCode", label: "従業員コード" },
    { value: "dailyWorkHours", label: "日の勤務時間（休憩時間実績/必要休憩時間）" },
];

/**
 * デフォルト設定
 */
export const DEFAULT_DAILY_SHIFT_CELL_DISPLAY: DailyShiftCellDisplaySettings = {
    area1: "employeeName",
    area2: "employmentType",
    area3: "dailyWorkHours",
};

/**
 * サンプルデータ（プレビュー用）
 */
export interface DailySampleEmployeeData {
    employeeName: string;
    employmentType: string;
    employeeCode: string;
    dailyWorkHours: string;
}

export const DAILY_SAMPLE_EMPLOYEES: DailySampleEmployeeData[] = [
    {
        employeeName: "田中太郎",
        employmentType: "社員",
        employeeCode: "EMP001",
        dailyWorkHours: "8.0h（30分/60分）",
    },
    {
        employeeName: "佐藤花子",
        employmentType: "パートナー",
        employeeCode: "EMP002",
        dailyWorkHours: "4.5h（0分/0分）",
    },
    {
        employeeName: "鈴木一郎",
        employmentType: "アルバイト",
        employeeCode: "EMP003",
        dailyWorkHours: "8.0h（60分/60分）",
    },
];

/**
 * 選択値からサンプルデータの表示テキストを取得
 */
export const getDailyDisplayText = (
    option: DailyArea1Option | DailyArea2And3Option,
    data: DailySampleEmployeeData
): string => {
    switch (option) {
        case "employeeName":
            return data.employeeName;
        case "employmentType":
            return data.employmentType;
        case "employeeCode":
            return data.employeeCode;
        case "dailyWorkHours":
            return data.dailyWorkHours;
        case "none":
            return "";
        default:
            return "";
    }
};
